<script setup lang="ts">
// types
import type { StrapiFooterSocialLink } from '@ts-strapi/interfaces'
// components
import { AppText } from '@UI/Typography/AppText'
import { LinkBase } from '@UI/Links/LinkBase'
import { AppIconStrapi } from '@UI/Icons/AppIconStrapi'

defineOptions({
  name: 'FooterSocials',
})

defineProps<{
  label: string
  items: StrapiFooterSocialLink[]
}>()
</script>

<template>
  <section class="footer-socials">
    <AppText
      tag="p"
      name="body3-medium"
      color="white"
    >
      {{ label }}
    </AppText>

    <div class="footer-socials__row">
      <LinkBase
        v-for="item in items"
        :key="item.url"
        class="footer-socials__link"
        :link="{ label: item.label ?? '', url: item.url, newTab: item.newTab }"
        :aria-label="item.label ?? item.icon.iconName ?? 'social link'"
      >
        <AppIconStrapi
          :icon="item.icon"
          size="big"
          color="white"
        />
      </LinkBase>
    </div>
  </section>
</template>

<style scoped lang="scss" src="@scss/components/Widgets/Footers/FooterSocials.scss" />
